// // import React, { createContext, useContext, useState, useEffect } from "react";

// // export const AuthContext = createContext();

// // export const AuthProvider = ({ children }) => {
// //   // Load directly from localStorage (so no null flash)
// //   const [authenticated, setAuthenticated] = useState(
// //     localStorage.getItem("authenticated") === "true"
// //   );
// //   const [isAdmin, setIsAdmin] = useState(
// //     localStorage.getItem("isAdmin") === "true"
// //   );

// //   // Keep both values in sync with localStorage
// //   useEffect(() => {
// //     localStorage.setItem("authenticated", authenticated);
// //     localStorage.setItem("isAdmin", isAdmin);
// //   }, [authenticated, isAdmin]);

// //   return (
// //     <AuthContext.Provider
// //       value={{ authenticated, setAuthenticated, isAdmin, setIsAdmin }}
// //     >
// //       {children}
// //     </AuthContext.Provider>
// //   );
// // };

// // export const useAuth = () => useContext(AuthContext);



















// import React, { createContext, useContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   // ✅ INITIAL LOAD (no flicker)
//   const [authenticated, setAuthenticated] = useState(() => {
//     return localStorage.getItem("authenticated") === "true";
//   });

//   const [isAdmin, setIsAdmin] = useState(() => {
//     return localStorage.getItem("isAdmin") === "true";
//   });

//   // ✅ SYNC TO LOCAL STORAGE
//   useEffect(() => {
//     localStorage.setItem("authenticated", authenticated);
//     localStorage.setItem("isAdmin", isAdmin);
//   }, [authenticated, isAdmin]);

//   // 🔥 MULTI-TAB SYNC (IMPORTANT)
//   useEffect(() => {
//     const handleStorageChange = () => {
//       const auth = localStorage.getItem("authenticated") === "true";
//       const admin = localStorage.getItem("isAdmin") === "true";

//       setAuthenticated(auth);
//       setIsAdmin(admin);
//     };

//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//     };
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{ authenticated, setAuthenticated, isAdmin, setIsAdmin }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);















import React, { createContext, useContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(
    localStorage.getItem("authenticated") === "true"
  );

  const [isAdmin, setIsAdmin] = useState(
    localStorage.getItem("isAdmin") === "true"
  );

  useEffect(() => {
    localStorage.setItem("authenticated", authenticated);
    localStorage.setItem("isAdmin", isAdmin);
  }, [authenticated, isAdmin]);

  return (
    <AuthContext.Provider
      value={{ authenticated, setAuthenticated, isAdmin, setIsAdmin }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);